import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai";
import { FiGlobe } from "react-icons/fi";
import { apiPut, apiDelete } from "../../utils/apiFetch";
import { useTranslation } from "react-i18next";
import { useState, useContext } from "react"; // Added useContext
import dayjs from "dayjs";
import apiPath from "../../utils/pathObj";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";
import StaffIpModal from "components/geoAccess/StaffIpModal";
import AuthContext from "context/AuthContext"; // Added AuthContext

const AccountantOnboardingList = ({ accountantOnboardingList, page, allOnboarding, handleEdit, handleView, sort, setSort }) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const { fetchCompanyCompletionStatus } = useContext(AuthContext); // Added fetchCompanyCompletionStatus
  const [ipItem, setIpItem] = useState(null);

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.accountantOnboardingStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allOnboarding();
        if (fetchCompanyCompletionStatus) fetchCompanyCompletionStatus(); // Refresh status
      }
    } catch (error) {
      console.log("error in get all accountant list==>>>>", error.message);
    }
  };

  const handleDeleteAccountant = async (id) => {
    try {
      const path = `${apiPath.accountantOnboardingDelete}/${id}`;
      const result = await apiDelete(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allOnboarding({ deletePage: true });
        if (fetchCompanyCompletionStatus) fetchCompanyCompletionStatus(); // Refresh status
      }
    } catch (error) {
      console.log("error in delete accountant==>>>>", error.message);
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  Sr no.
                </th>
                <th className="px-6 py-3" scope="col">
                  {t("ACCOUNTANT_ID")}
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("ACCOUNTANT_NAME")}
                </th>

                <th
                  className="py-3 cursor-pointer px-6 "
                  onClick={() => {
                    if (sort.sortType === "asc" && sort.sortBy === "email") {
                      setSort({
                        sortBy: "email",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortBy: "email",
                        sortType: "asc",
                      });
                    }
                  }}
                  scope="col"
                >
                  <div className="justify-start flex">
                    <span>{t("EMAIL_ID")}</span>
                    <span>
                      {sort.sortType === "asc" && sort.sortBy === "email" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortType === "desc" && sort.sortBy === "email" && <BsArrowUpShort className="h-4 rotate-180 w-4 " />}
                    </span>
                  </div>
                </th>
                <th className="py-3 px-6" scope="col">
                  {t("MOBILE_NUMBER")}
                </th>
                <th
                  className="py-3 px-6 cursor-pointer"
                  scope="col"
                  onClick={() => {
                    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "createdAt",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="h-4 w-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                    </span>
                  </div>
                </th>
                <th className="py-3 text-center px-6 " scope="col">
                  {t("O_STATUS")}
                </th>
                <th scope="col" className="px-6 text-center py-3 ">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {accountantOnboardingList &&
                accountantOnboardingList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.accountantId}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>

                      <td className="px-6 border-r py-4 text-gray-900">{item?.email}</td>
                      <td className="border-r text-gray-900 py-4 px-6 ">
                        +({item?.countryCode}) {item?.mobile}
                      </td>
                      <td className="text-left py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="text-gray-900 py-4 px-6 border-r text-center">
                        <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="cursor-pointer inline-flex relative items-center ">
                          <input
                            className="sr-only peer"
                            type="checkbox"
                            onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
                            checked={item?.status === "active"}
                          />
                          <div className="peer w-10 h-5 bg-gray-200 rounded-full peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>
                      <td className="py-4 px-6 border-l text-gray-900">
                        <div className="">
                          <ul className="flex justify-center">
                            <li onClick={() => handleEdit(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
                              <a title="Edit" data-bs-toggle="tooltip" className="ease-in-out hover:text-blue-700 transition duration-150 ">
                                {" "}
                                <AiFillEdit className="text-slate-600 cursor-pointer w-5 h-5 " />
                              </a>
                            </li>
                            <li onClick={() => setIpItem(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
                              <a title={t("GEO_MANAGE_IPS")}>
                                <FiGlobe className="cursor-pointer w-5 h-5 text-slate-600" />
                              </a>
                            </li>
                            <li onClick={() => handleView(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
                              <a title="View">
                                {" "}
                                <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                              </a>
                            </li>
                            <li
                              onClick={() => {
                                helper.alertFunction(
                                  `Are you sure you want to delete Accountant '${item?.name}'?`,
                                  item?._id,
                                  handleDeleteAccountant,
                                  true
                                );
                              }}
                              className="px-2 py-2 hover:bg-white hover:text-red-500 cursor-pointer"
                            >
                              <a title={t("O_DELETE_USER")}>
                                <AiFillDelete className="w-5 h-5 text-slate-600 hover:text-red-600" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(accountantOnboardingList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={8}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      {ipItem && (
        <StaffIpModal
          item={ipItem}
          role="AccountantAdmin"
          title={t("GEO_SECTION_ACCOUNTANT")}
          onClose={() => setIpItem(null)}
        />
      )}
    </div>
  );
};

export default AccountantOnboardingList;


// import useToastContext from "hooks/useToastContext";
// import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai";
// import { FiGlobe } from "react-icons/fi";
// import { apiPut, apiDelete } from "../../utils/apiFetch";
// import { useTranslation } from "react-i18next";
// import { useState } from "react";
// import dayjs from "dayjs";
// import apiPath from "../../utils/pathObj";
// import { isEmpty } from "lodash";
// import helper from "../../utils/helpers";
// import { BsArrowUpShort } from "react-icons/bs";
// import StaffIpModal from "components/geoAccess/StaffIpModal";

// const AccountantOnboardingList = ({ accountantOnboardingList, page, allOnboarding, handleEdit, handleView, sort, setSort }) => {
//   const notification = useToastContext();
//   const { t } = useTranslation();
//   const [ipItem, setIpItem] = useState(null);

//   const handelStatusChange = async (item) => {
//     try {
//       const payload = {
//         status: item?.status === "inactive" ? "active" : "inactive",
//       };
//       const path = `${apiPath.accountantOnboardingStatus}/${item?._id}`;
//       const result = await apiPut(path, payload);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allOnboarding();
//       }
//     } catch (error) {
//       console.log("error in get all accountant list==>>>>", error.message);
//     }
//   };

//   const handleDeleteAccountant = async (id) => {
//     try {
//       const path = `${apiPath.accountantOnboardingDelete}/${id}`;
//       const result = await apiDelete(path);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allOnboarding({ deletePage: true });
//       }
//     } catch (error) {
//       console.log("error in delete accountant==>>>>", error.message);
//     }
//   };

//   return (
//     <div>
//       <div className="p-3">
//         <div className="overflow-x-auto relative rounded-lg border">
//           <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
//             <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
//               <tr>
//                 <th scope="col" className="py-3 px-6">
//                   Sr no.
//                 </th>
//                 <th className="px-6 py-3" scope="col">
//                   {t("ACCOUNTANT_ID")}
//                 </th>
//                 <th scope="col" className="px-6 py-3">
//                   {t("ACCOUNTANT_NAME")}
//                 </th>

//                 <th
//                   className="py-3 cursor-pointer px-6 "
//                   onClick={() => {
//                     if (sort.sortType === "asc" && sort.sortBy === "email") {
//                       setSort({
//                         sortBy: "email",
//                         sortType: "desc",
//                       });
//                     } else {
//                       setSort({
//                         sortBy: "email",
//                         sortType: "asc",
//                       });
//                     }
//                   }}
//                   scope="col"
//                 >
//                   <div className="justify-start flex">
//                     <span>{t("EMAIL_ID")}</span>
//                     <span>
//                       {sort.sortType === "asc" && sort.sortBy === "email" && <BsArrowUpShort className="w-4 h-4" />}
//                       {sort.sortType === "desc" && sort.sortBy === "email" && <BsArrowUpShort className="h-4 rotate-180 w-4 " />}
//                     </span>
//                   </div>
//                 </th>
//                 <th className="py-3 px-6" scope="col">
//                   {t("MOBILE_NUMBER")}
//                 </th>
//                 <th
//                   className="py-3 px-6 cursor-pointer"
//                   scope="col"
//                   onClick={() => {
//                     if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
//                       setSort({
//                         sortBy: "createdAt",
//                         sortType: "desc",
//                       });
//                     } else {
//                       setSort({
//                         sortType: "asc",
//                         sortBy: "createdAt",
//                       });
//                     }
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("CREATED_DATE")}</span>
//                     <span>
//                       {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="h-4 w-4" />}
//                       {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
//                     </span>
//                   </div>
//                 </th>
//                 <th className="py-3 text-center px-6 " scope="col">
//                   {t("O_STATUS")}
//                 </th>
//                 <th scope="col" className="px-6 text-center py-3 ">
//                   {t("O_ACTION")}
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {accountantOnboardingList &&
//                 accountantOnboardingList.map((item, i) => {
//                   return (
//                     <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
//                       <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
//                         {i + 1 + 10 * (page - 1)}
//                       </th>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.accountantId}</td>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>

//                       <td className="px-6 border-r py-4 text-gray-900">{item?.email}</td>
//                       <td className="border-r text-gray-900 py-4 px-6 ">
//                         +({item?.countryCode}) {item?.mobile}
//                       </td>
//                       <td className="text-left py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
//                       <td className="text-gray-900 py-4 px-6 border-r text-center">
//                         <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="cursor-pointer inline-flex relative items-center ">
//                           <input
//                             className="sr-only peer"
//                             type="checkbox"
//                             onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
//                             checked={item?.status === "active"}
//                           />
//                           <div className="peer w-10 h-5 bg-gray-200 rounded-full peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
//                         </label>
//                       </td>
//                       <td className="py-4 px-6 border-l text-gray-900">
//                         <div className="">
//                           <ul className="flex justify-center">
//                             <li onClick={() => handleEdit(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
//                               <a title="Edit" data-bs-toggle="tooltip" className="ease-in-out hover:text-blue-700 transition duration-150 ">
//                                 {" "}
//                                 <AiFillEdit className="text-slate-600 cursor-pointer w-5 h-5 " />
//                               </a>
//                             </li>
//                             <li onClick={() => setIpItem(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
//                               <a title={t("GEO_MANAGE_IPS")}>
//                                 <FiGlobe className="cursor-pointer w-5 h-5 text-slate-600" />
//                               </a>
//                             </li>
//                             <li onClick={() => handleView(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
//                               <a title="View">
//                                 {" "}
//                                 <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
//                               </a>
//                             </li>
//                             <li
//                               onClick={() => {
//                                 helper.alertFunction(
//                                   `Are you sure you want to delete Accountant '${item?.name}'?`,
//                                   item?._id,
//                                   handleDeleteAccountant,
//                                   true
//                                 );
//                               }}
//                               className="px-2 py-2 hover:bg-white hover:text-red-500 cursor-pointer"
//                             >
//                               <a title={t("O_DELETE_USER")}>
//                                 <AiFillDelete className="w-5 h-5 text-slate-600 hover:text-red-600" />
//                               </a>
//                             </li>
//                           </ul>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               {isEmpty(accountantOnboardingList) ? (
//                 <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
//                   <td className="py-4 px-6 border-r" colSpan={8}>
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       {ipItem && (
//         <StaffIpModal
//           item={ipItem}
//           role="AccountantAdmin"
//           title={t("GEO_SECTION_ACCOUNTANT")}
//           onClose={() => setIpItem(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default AccountantOnboardingList;





// import useToastContext from "hooks/useToastContext";
// import { AiFillEdit, AiFillEye } from "react-icons/ai";
// import { FiGlobe } from "react-icons/fi";
// import { apiPut } from "../../utils/apiFetch";
// import { useTranslation } from "react-i18next";
// import { useState } from "react";
// import dayjs from "dayjs";
// import apiPath from "../../utils/pathObj";
// import { isEmpty } from "lodash";
// import helper from "../../utils/helpers";
// import { BsArrowUpShort } from "react-icons/bs";
// import StaffIpModal from "components/geoAccess/StaffIpModal";

// const AccountantOnboardingList = ({ accountantOnboardingList, page, allOnboarding, handleEdit, handleView, sort, setSort }) => {
//   const notification = useToastContext();
//   const { t } = useTranslation();
//   const [ipItem, setIpItem] = useState(null);

//   const handelStatusChange = async (item) => {
//     try {
//       const payload = {
//         status: item?.status === "inactive" ? "active" : "inactive",
//       };
//       const path = `${apiPath.accountantOnboardingStatus}/${item?._id}`;
//       const result = await apiPut(path, payload);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allOnboarding();
//       }
//     } catch (error) {
//       console.log("error in get all accountant list==>>>>", error.message);
//     }
//   };

//   return (
//     <div>
//       <div className="p-3">
//         <div className="overflow-x-auto relative rounded-lg border">
//           <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
//             <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
//               <tr>
//                 <th scope="col" className="py-3 px-6">
//                   Sr no.
//                 </th>
//                 <th className="px-6 py-3" scope="col">
//                   {t("ACCOUNTANT_ID")}
//                 </th>
//                 <th scope="col" className="px-6 py-3">
//                   {t("ACCOUNTANT_NAME")}
//                 </th>

//                 <th
//                   className="py-3 cursor-pointer px-6 "
//                   onClick={() => {
//                     if (sort.sortType === "asc" && sort.sortBy === "email") {
//                       setSort({
//                         sortBy: "email",
//                         sortType: "desc",
//                       });
//                     } else {
//                       setSort({
//                         sortBy: "email",
//                         sortType: "asc",
//                       });
//                     }
//                   }}
//                   scope="col"
//                 >
//                   <div className="justify-start flex">
//                     <span>{t("EMAIL_ID")}</span>
//                     <span>
//                       {sort.sortType === "asc" && sort.sortBy === "email" && <BsArrowUpShort className="w-4 h-4" />}
//                       {sort.sortType === "desc" && sort.sortBy === "email" && <BsArrowUpShort className="h-4 rotate-180 w-4 " />}
//                     </span>
//                   </div>
//                 </th>
//                 <th className="py-3 px-6" scope="col">
//                   {t("MOBILE_NUMBER")}
//                 </th>
//                 <th
//                   className="py-3 px-6 cursor-pointer"
//                   scope="col"
//                   onClick={() => {
//                     if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
//                       setSort({
//                         sortBy: "createdAt",
//                         sortType: "desc",
//                       });
//                     } else {
//                       setSort({
//                         sortType: "asc",
//                         sortBy: "createdAt",
//                       });
//                     }
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("CREATED_DATE")}</span>
//                     <span>
//                       {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="h-4 w-4" />}
//                       {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
//                     </span>
//                   </div>
//                 </th>
//                 <th className="py-3 text-center px-6 " scope="col">
//                   {t("O_STATUS")}
//                 </th>
//                 <th scope="col" className="px-6 text-center py-3 ">
//                   {t("O_ACTION")}
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {accountantOnboardingList &&
//                 accountantOnboardingList.map((item, i) => {
//                   return (
//                     <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
//                       <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
//                         {i + 1 + 10 * (page - 1)}
//                       </th>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.accountantId}</td>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>

//                       <td className="px-6 border-r py-4 text-gray-900">{item?.email}</td>
//                       <td className="border-r text-gray-900 py-4 px-6 ">
//                         +({item?.countryCode}) {item?.mobile}
//                       </td>
//                       <td className="text-left py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
//                       <td className="text-gray-900 py-4 px-6 border-r text-center">
//                         <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="cursor-pointer inline-flex relative items-center ">
//                           <input
//                             className="sr-only peer"
//                             type="checkbox"
//                             onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
//                             checked={item?.status === "active"}
//                           />
//                           <div className="peer w-10 h-5 bg-gray-200 rounded-full peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
//                         </label>
//                       </td>
//                       <td className="py-4 px-6 border-l text-gray-900">
//                         <div className="">
//                           <ul className="flex justify-center">
//                             <li onClick={() => handleEdit(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
//                               <a title="Edit" data-bs-toggle="tooltip" className="ease-in-out hover:text-blue-700 transition duration-150 ">
//                                 {" "}
//                                 <AiFillEdit className="text-slate-600 cursor-pointer w-5 h-5 " />
//                               </a>
//                             </li>
//                             <li onClick={() => setIpItem(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
//                               <a title={t("GEO_MANAGE_IPS")}>
//                                 <FiGlobe className="cursor-pointer w-5 h-5 text-slate-600" />
//                               </a>
//                             </li>
//                             <li onClick={() => handleView(item)} className="hover:text-LightBlue px-2 py-2 hover:bg-white ">
//                               <a title="View">
//                                 {" "}
//                                 <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
//                               </a>
//                             </li>
//                           </ul>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               {isEmpty(accountantOnboardingList) ? (
//                 <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
//                   <td className="py-4 px-6 border-r" colSpan={8}>
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       {ipItem && (
//         <StaffIpModal
//           item={ipItem}
//           role="AccountantAdmin"
//           title={t("GEO_SECTION_ACCOUNTANT")}
//           onClose={() => setIpItem(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default AccountantOnboardingList;
